import { render, staticRenderFns } from "./CustomTabs.vue?vue&type=template&id=4379cf7b&scoped=true"
import script from "./CustomTabs.vue?vue&type=script&lang=js"
export * from "./CustomTabs.vue?vue&type=script&lang=js"
import style0 from "./CustomTabs.vue?vue&type=style&index=0&id=4379cf7b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4379cf7b",
  null
  
)

export default component.exports